module.exports = __webpack_public_path__ + "first-20-ir.jpg?e3abe8938bed08ffb910848e27ca4906";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-20-ir.jpg
// module id = 458
// module chunks = 0